import React from 'react';
import {useNavigate} from 'react-router-dom';
import {StyledBreadcrumbs, StyledTypography} from './styles';
import {BreadcrumbsTypes} from './types';

export const Breadcrumbs = ({paths}: BreadcrumbsTypes) => {
	const navigate = useNavigate();
	const handleClick = (path: BreadcrumbsTypes['paths'][number]) => {
		if (path.route) {
			navigate(path.route);
		} else if (path.callback) {
			path.callback();
		}
	};
	return (
		<StyledBreadcrumbs>
			{paths.map((path, index) => {
				const isLast = !path.route && !path.callback;
				if (isLast) {
					return (
						<StyledTypography key={index} isLast={true}>
							{path.title}
						</StyledTypography>
					);
				}
				return (
					<StyledTypography key={index} isLast={false} onClick={() => handleClick(path)}>
						{path.title}
					</StyledTypography>
				);
			})}
		</StyledBreadcrumbs>
	);
};
